"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerQueryReceivables = exports.GetReceivablesQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.GetReceivablesQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    customerID: typebox_1.Type.String(),
    receivableID: typebox_1.Type.String(),
    void: typebox_1.Type.Boolean(),
    issuedBefore: typebox_1.Type.String(),
    issuedAfter: typebox_1.Type.String(),
    issued: typebox_1.Type.Boolean(),
    dueBefore: typebox_1.Type.String(),
    dueAfter: typebox_1.Type.String(),
    invoiceNumber: typebox_1.Type.String(),
    orderID: typebox_1.Type.String(),
    syncedWithAccounting: typebox_1.Type.Boolean(),
    paidInFull: typebox_1.Type.Boolean(),
    productInvoiceGroupingID: typebox_1.Type.String(),
    receivableWithLineItemWithServiceOrderID: typebox_1.Type.String(),
    serviceGroupingID: typebox_1.Type.String(),
    commercialBillingActivityID: typebox_1.Type.String(),
    commercialSubscriptionID: typebox_1.Type.String(),
    hasPayments: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    payoutID: typebox_1.Type.String(),
    referenceID: typebox_1.Type.String(),
    referenceType: common_1.EntityType,
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortDescending: typebox_1.Type.Boolean(),
    nullsLast: typebox_1.Type.Boolean(),
}));
exports.CustomerQueryReceivables = typebox_1.Type.Partial(typebox_1.Type.Object({
    void: typebox_1.Type.Boolean(),
    issuedBefore: typebox_1.Type.String(),
    issuedAfter: typebox_1.Type.String(),
    dueBefore: typebox_1.Type.String(),
    dueAfter: typebox_1.Type.String(),
    paymentsBefore: typebox_1.Type.String(),
    paymentsAfter: typebox_1.Type.String(),
    invoiceNumber: typebox_1.Type.String(),
    orderID: typebox_1.Type.String(),
    serviceGroupingID: typebox_1.Type.String(),
    receivableID: typebox_1.Type.String(),
    paidInFull: typebox_1.Type.Boolean(),
    commercialBillingActivityID: typebox_1.Type.String(),
    commercialSubscriptionID: typebox_1.Type.String(),
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortDescending: typebox_1.Type.Boolean(),
    nullsLast: typebox_1.Type.Boolean(),
}));
//# sourceMappingURL=get-receivables-query.js.map